

function getLogoface() {
  return "static/img/logo.png"
}

import menuStore from "./menu"

export default {
  name: "core",
  module: {
    state: {
      faceImgDt: new Date().getTime(), //头像图片缓存时间戳
      relogin: false,
      reloginRefresh: false,
      user: {},
      // userface: "", //用户头像
      loginbg: "", //登陆页背景
      logoUrl: "", //logo
      getFacebyUserID: function (userid) {
        return `documents/user/${userid}/face.jpg?t=` + this.faceImgDt
      },
      getLoginbg: function (userid, t) {
        if (t) return `documents/user/${userid}/Loginbg.jpg?t=` + t
        return `documents/user/${userid}/Loginbg.jpg`
      },
      menuWidth: "58px", //pc布局默认侧边栏菜单宽度
      maxMenuWidth: "260px", //最大侧边栏宽度,
      maxMenuWidthPc3: "280px",//Pc3最大侧边栏宽度,
      menuWidthforVs: "260px", //vs布局默认侧边栏菜单宽度
      thema: "", //默认主题色
      layout: "",
      menuKey: "",
      pc2: { sideBarImg: "" }, //pc2布局配置
      top: { topImg: "" }, //顶部布局配置
      themaColor: {
        basetextcolor: "",
      },
      customTitle: "",
      unreadMsgNum: "", //未读消息数
      isUiStyle: null, //是否自定义ui界面
      uiKey: "", //自定义UI标识
      // uistyle:[], //自定义UI配置
      headline: null,
    },
    mutations: {
      setPC2SideBarImg(state, elem) {
        //pc2侧边图修改
        let sideBarImg = (elem && elem.sideBarImg) || "static/img/sidebar-pc2.jpg"
        state.pc2.sideBarImg = sideBarImg
        // console.log(state.pc2.sideBarImg, "--------pc2");
      },
      setTopImg(state, elem) {
        //top顶部图修改
        let topImg = (elem && elem.topImg) || "/static/img/sidebar-top.png"
        state.top.topImg = topImg
        // console.log(state.top.topImg, "--------top");
      },
      setUser(state, user) {
        state.user = user
      },
      setLayout(state, val) {
        state.layout = val
      },
      setMenuKey(state, val) {
        state.menuKey = val
      },
      setRelogin(state, type) {
        if (type == undefined) type = true
        state.relogin = type
      },
      setReloginRefresh(state, type) {
        state.reloginRefresh = type
      },
      setThema(state, value) {
        let theme = {
          light: {
            basetextcolor: "#37404A",
          },
          dark: {
            basetextcolor: "#ccc",
          },
          blue: {
            basetextcolor: "#37404A",
          },
        }

        //根据地址栏选择色调
        value = window.QueryDict["color"] || value

        state.themaColor = theme[value]

        state.thema = value
        let bodyel = document.getElementsByTagName("body")[0]
        if (value) {
          bodyel.classList.remove("light", "dark", "blue")
          bodyel.classList.add(value)
        }
      },
      setMenuWidth(state, value) {
        state.menuWidth = value
      },

      setUserface(state, value) {
        state.faceImgDt = new Date().getTime()
        // state.userface=this.getFacebyUserID(state.user.userid);
      },
      setLoginbg() {
        state.loginbg = state.getLoginbg(state.user.userid, new Date())
      },
      setMenuWidthforVs(state, value) {
        state.maxMenuWidth = value
      },
      setMenuWidthforPc3(state, value) {
        state.maxMenuWidthPc3 = value
      },
      setCustomTitle(state, value) {
        state.customTitle = value
      },
      setUnreadMsgNum(state, value) {
        state.unreadMsgNum = value
      },
      isUiStyle(state, value) {
        state.isUiStyle = value
      },
      // setUistyle(state, value){
      //   state.uistyle = value
      // },
      setHeadline(state, value) {
        state.headline = value
      },
      setUiKey(state, value) {
        state.uiKey = value
      },
    },
    actions: {
      logout() {
        this.$app.curl.post("/api/core/logout").then(async () => {
          if (typeof plus != "undefined") {
            //手机端退出登录 清除 localstorage
            plus.storage.clear()
          }
          let locationKey = `autologin:${location.host}`
          localStorage.setItem(locationKey, JSON.stringify({ enable: false }))
          window.localCookieInstance.clearcookies()

          let app = this.$app
          try {
            await app.hookexec(app, "onLogout")
            let res = await fxImport("./web/config/core/hook.config.js")
            if (res && typeof res.onLogout == "function") res.onLogout()
          } finally {
            try {
              if (window.self.frameElement && window.self.frameElement.tagName == "IFRAME") {
                var exec_obj = document.createElement("iframe");
                exec_obj.name = "tmp_frame";
                exec_obj.src = window.topbashhost + "iframe/logout.html" + "&r=" + new Date().getTime();
                exec_obj.style.display = "none";
                document.body.appendChild(exec_obj); //动态创建一个iframe
              } else if (window.QueryDict["refererhost"]) {
                location.href = window.QueryDict["refererhost"];
                return
              }
            } catch (error) {

            }
            location.href = "login.html";
          }

        })
      },

      setLogoface(context, args) {
        let tryurl = `static/img/logo-${args}.png`
        let defaulturl =  `static/img/logo.png`
        new Promise(function (resolve, reject) {
          var ImgObj = new Image()
          ImgObj.src = tryurl
          ImgObj.onload = function () {
            // console.log(ImgObj.width+"==",ImgObj.height+"==");
            resolve("load image success")
          }
          ImgObj.onerror = function () {
            reject("Could not load image at " + tryurl)
          }
        }).then(
          function (res) {
            // console.log(res)
            context.state.logoUrl = tryurl
          },
          function (err) {
            // console.log(err)
            context.state.logoUrl = defaulturl
          }
        )
      },
    },
    modules: {
      menuStore,
    },
  },
}
